import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"overflow":"hidden","width":"560px"} }
const _hoisted_2 = { class: "field-group q-mt-sm" }
const _hoisted_3 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_4 = { class: "bold-name q-mr-xs" }
const _hoisted_5 = { class: "field-group q-mt-sm" }
const _hoisted_6 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_7 = { class: "bold-name q-mr-xs" }
const _hoisted_8 = {
  key: 0,
  class: "field-group q-mt-sm"
}
const _hoisted_9 = { class: "field-group__row no-wrap items-baseline justify-between" }
const _hoisted_10 = { class: "bold-name q-mr-xs" }
const _hoisted_11 = { class: "field-group q-mt-sm" }
const _hoisted_12 = { class: "bold-name q-mr-xs q-mt-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_native_input = _resolveComponent("native-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('invoice_type')) + ":", 1),
        _createVNode(_component_q_select, {
          flat: "",
          modelValue: _ctx.theModel.billType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.billType) = $event)),
          style: {"min-width":"150px","padding":"0 !important"},
          class: "thin-input",
          "dropdown-icon": "expand_more",
          "fill-input": "",
          "bottom-slots": false,
          disable: _ctx.incomingOnly,
          dense: "",
          outlined: "",
          "input-debounce": "500",
          "emit-value": "",
          "map-options": "",
          "option-label": "Name",
          "option-value": "Id",
          ref: "from_select",
          options: _ctx.typeOptions
        }, null, 8, ["modelValue", "disable", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('amount')) + ":", 1),
        _createVNode(_component_native_input, {
          ref: "amount_input",
          style: {"min-width":"150px"},
          modelValue: _ctx.theModel.billAmount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.theModel.billAmount) = $event)),
          "input-type": "number",
          "edit-on-click": true,
          "show-border": true,
          "min-number-value": 0
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_ctx.theModel.billType === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('number')) + ":", 1),
            _createVNode(_component_native_input, {
              style: {"min-width":"150px"},
              ref: "number_input",
              "show-border": true,
              "edit-on-click": true,
              modelValue: _ctx.theModel.billNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel.billNumber) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('comment')) + ":", 1),
      _createVNode(_component_native_input, {
        style: {"max-width":"100%","min-width":"100%"},
        ref: "comment_input",
        modelValue: _ctx.theModel.billNote,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.theModel.billNote) = $event)),
        "edit-on-click": true,
        "show-border": true
      }, null, 8, ["modelValue"])
    ])
  ]))
}